export enum ThemePrimaryTextColor {
  White = 'WHITE',
  Black = 'BLACK',
}
